import Component from "@base/Component.js";
import config from "@/config.js";

/**
 * Full-screen landing hero: welcome image behind a diagonal triangle panel
 * carrying the brand heading — same diagonal-clip language as the gallery
 * detail story/map diptych, just one panel instead of two. Home route only
 * (the gallery detail view never mounts this).
 *
 * Display-only: the image is uploaded and removed in the Cockpit's Landing Page
 * Top Image Editor (#/cockpit/hero), so visitors and admins see the same hero.
 * props: { heroImage: string|null }
 */
export default class Hero extends Component {
  render() {
    const { heroImage } = this.props;

    const img = heroImage
      ? `<img class="hero__img" src="${config.imageBase}/site/${encodeURIComponent(heroImage)}" alt="" />`
      : "";

    const heading = `
      <div class="hero__panel">
        <div class="hero__panel-inner">
          <div class="hero__kicker">by Dario Bolzern</div>
          <h1 class="hero__title">Picturefox</h1>
          <div class="hero__rule"></div>
        </div>
      </div>`;

    return `<div class="hero${heroImage ? "" : " hero--empty"}">${img}${heading}</div>`;
  }
}
